import { RootObject, Content5 } from '../../type';


import './style.less';
const EventAward = (props: RootObject["eventAward"]) => {
    const {
        bFrameImf,
        zhTitle,
        enTitle,
        content,
        introTitle,
        introDesc
    } = props;
    return (
        <div className='p-p-foundathon-eventAward'>
            <div className='p-p-foundathon-eventAward-zh-title'>
                {
                    zhTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-eventAward-en-title'>
                {
                    enTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-eventAward-content' style={{ background: `url(${bFrameImf})` }}>
                <div className='p-p-foundathon-eventAward-content-modules'>
                    {
                        content.map((item: Content5, index: number) => {
                            return (
                                <div className='p-p-foundathon-eventAward-content-modules-module' key={index}>
                                    <img src={item.timeContent.lEarImg} alt="" className='p-p-foundathon-eventAward-content-modules-module-l' />
                                    <div className='p-p-foundathon-eventAward-content-modules-module-c'>
                                        <div className='p-p-foundathon-eventAward-content-modules-module-c-title'>
                                            {
                                                item.timeContent.title
                                            }
                                        </div>
                                        <div className='p-p-foundathon-eventAward-content-modules-module-c-desc'>
                                                {
                                                    item.timeContent.amount.split('&').map(item => <div className='p-p-foundathon-eventAward-content-modules-module-c-desc-amount'>
                                                        {item}
                                                    </div>)
                                                }
                                            
                                            {/* {
                                                item.timeContent.amountDesc ? */}
                                                    <div className='p-p-foundathon-eventAward-content-modules-module-c-desc-amount-desc'>
                                                        {
                                                            item.timeContent.amountDesc ?? ''
                                                        }
                                                    </div>
                                                    {/* :
                                                    null
                                            } */}
                                        </div>
                                        <div className='p-p-foundathon-eventAward-content-modules-module-c-tips'>
                                            {
                                                item.timeContent.tips
                                            }
                                        </div>
                                    </div>
                                    <img src={item.timeContent.rEarImg} alt="" className='p-p-foundathon-eventAward-content-modules-module-r' />
                                </div>
                            )
                        })
                    }
                </div>
                <div className='p-p-foundathon-eventAward-content-intro-title'>
                    {
                        introTitle ?? ''
                    }
                </div>
                <div className='p-p-foundathon-eventAward-content-intro-desc'>
                    {
                        introDesc ?? ''
                    }
                </div>
            </div>
            <div className='p-p-foundathon-eventAward-back'>

            </div>
        </div>
    )
}

export default EventAward;